(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /*
   * ============================================================
   * SCHENORR COLLECTION - DISCOUNT PERCENTAGE BADGE
   * ============================================================
   */

  function updateDiscountBadges(container) {
    const root = container || document;

    const productItems = root.querySelectorAll(
      '.product-grid__item[data-discount]'
    );

    productItems.forEach(function(productItem) {
      const discount = parseInt(
        productItem.getAttribute('data-discount'),
        10
      );

      if (!discount || discount <= 0) {
        return;
      }

      /*
       * Find the existing Shopify "Sale" badge.
       */
      const elements = productItem.querySelectorAll('*');

      elements.forEach(function(element) {
        if (element.children.length === 0) {
          const text = element.textContent.trim().toLowerCase();

          if (text === 'sale') {
            element.textContent = '-' + discount + '%';

            element.setAttribute(
              'data-discount-badge',
              'true'
            );

            element.classList.add(
              'sch-discount-badge'
            );
          }
        }
      });
    });
  }


  /*
   * Initial page load
   */
  document.addEventListener(
    'DOMContentLoaded',
    function() {
      updateDiscountBadges(document);
    },
    { once: true }
  );


  /*
   * Run immediately too.
   */
  updateDiscountBadges(document);


  /*
   * Shopify infinite scroll / dynamically loaded products
   */
  const discountBadgeObserver = new MutationObserver(
    function(mutations) {
      let hasNewProducts = false;

      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          hasNewProducts = true;
        }
      });

      if (hasNewProducts) {
        updateDiscountBadges(document);
      }
    }
  );


  discountBadgeObserver.observe(document.body, {
    childList: true,
    subtree: true
  });


  /*
   * Shopify theme editor section reload
   */
  document.addEventListener(
    'shopify:section:load',
    function(event) {
      updateDiscountBadges(event.target);
    }
  );


  /*
   * Shopify section reorder
   */
  document.addEventListener(
    'shopify:section:reorder',
    function() {
      updateDiscountBadges(document);
    }
  );


  /*
   * Shopify section select
   */
  document.addEventListener(
    'shopify:section:select',
    function() {
      updateDiscountBadges(document);
    }
  );


  /*
   * Hash / anchor scrolling
   */
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      function() {
        const card = document.getElementById(
          url.hash.slice(1)
        );

        if (card) {
          card.scrollIntoView({
            behavior: 'instant'
          });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
